/**
 * Technology Filter Configuration
 *
 * Constants extracted to constants/ directory (Phase 1 - 2025-10-22)
 * Location: src/sections/technology/constants/filterWidths.ts
 *
 * Filter-specific helper functions.
 * NO JSX - pure TypeScript only.
 *
 * Pattern matches:
 * - src/sections/asset/config/filters.ts
 * - src/sections/seeds/config/filters.ts
 */

import { FILTER_DROPDOWN_WIDTHS } from '@/sections/technology/constants';

// Re-export constant for backward compatibility
export { FILTER_DROPDOWN_WIDTHS };

/**
 * Get dropdown width for a technology filter field
 *
 * @param fieldName - The filter field name
 * @returns The configured width or default width
 *
 * @example
 * ```tsx
 * const width = getFilterDropdownWidth('vendor'); // 600
 * const width = getFilterDropdownWidth('status'); // 400 (default)
 * ```
 */
export const getFilterDropdownWidth = (fieldName: string): number => {
  return (
    FILTER_DROPDOWN_WIDTHS[fieldName as keyof typeof FILTER_DROPDOWN_WIDTHS] ||
    FILTER_DROPDOWN_WIDTHS.default
  );
};
